import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "../style.scss";
import AdminService from "../../../../../services/AdminService";
import RoleService from "../../../../../services/RoleService";
import { Translate } from "../../../../Enums/Tranlate";

const AddAdminsModal = ({ addModal, setAddModal, item, setShouldUpdate }) => {
	const [formData, setFormData] = useState({
		username: "",
		phone: "",
		email: "",
		role: "",
		password: "",
	});
	const [showPassword, setShowPassword] = useState(false);
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const [rolesOptions, setRolesOptions] = useState([]);
	const lang = useSelector((state) => state.auth.lang);
	const adminService = new AdminService();
	const roleService = new RoleService();

	useEffect(() => {
		Promise.all([roleService.getList()]).then((res) => {
			if (res[0]?.status === 200) {
				let data = res[0]?.data?.data?.data?.map((info) => {
					return {
						label: info?.name,
						value: info?.id,
					};
				});
				setRolesOptions(data);
			}

			if (Object.keys(item)?.length === 0) {
				setIsAdd(true);
			} else {
				setIsAdd(false);
				setFormData({
					id: item?.id,
					name: item?.username,
					email: item?.email,
					phone: item?.phone,
					role: {
						label: item?.admin_permissions[0]?.admin_role?.name,
						value: item?.admin_permissions[0]?.admin_role_id,
					},
				});
			}
		});
	}, []);

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.role?.value) {
			return;
		}
		let data = {
			username: formData?.name,
			phone: formData?.phone,
			email: formData?.email,
			role_id: formData?.role?.value,
			password: formData?.password,
		};

		setLoading(true);
		if (isAdd) {
			adminService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			adminService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.admin}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						{/* Name */}
						<Col md={12}>
							<label className="text-label">{Translate[lang]?.name}</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name}
								onChange={(e) =>
									setFormData({
										...formData,
										name: e.target.value,
									})
								}
							/>
						</Col>
						{/* Phone */}
						<Col md={12} className="mb-3">
							<label>{Translate[lang]?.phone}</label>
							<PhoneInput
								country={"kw"}
								enableSearch={true}
								value={formData?.phone}
								onChange={(e) => setFormData({ ...formData, phone: e })}
							/>
						</Col>
						{/* Email */}
						<Col md={12}>
							<label>{Translate[lang]?.email}</label>
							<AvField
								type="email"
								placeholder={Translate[lang]?.email}
								bsSize="lg"
								name="email"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.email}
								onChange={(e) =>
									setFormData({
										...formData,
										email: e.target.value,
									})
								}
							/>
						</Col>
						{/* Password */}
						{isAdd && (
							<Col md={12} className="form-group mb-0 position-relative">
								<label>{Translate[lang]?.password}</label>
								<AvField
									type={showPassword ? "text" : "password"}
									placeholder={Translate[lang]?.password}
									bsSize="lg"
									className="radius-10"
									name="password"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.password}
									onChange={(e) =>
										setFormData({
											...formData,
											password: e.target.value,
										})
									}
								/>
								{showPassword ? (
									<i
										className="la la-eye-slash position-absolute cursor-pointer"
										style={{
											top: "44px",
											right: lang === "en" ? "8%" : "auto",
											left: lang === "ar" ? "8%" : "auto",
										}}
										onClick={() => setShowPassword(false)}></i>
								) : (
									<i
										className="la la-eye position-absolute cursor-pointer"
										style={{
											top: "44px",
											right: lang === "en" ? "8%" : "auto",
											left: lang === "ar" ? "8%" : "auto",
										}}
										onClick={() => setShowPassword(true)}></i>
								)}
							</Col>
						)}
						{/* Role */}
						<Col md={12}>
							<label className="text-label">{Translate[lang]?.role}</label>
							<Select
								value={formData?.role}
								name="role"
								placeholder={Translate[lang]?.select}
								options={rolesOptions}
								onChange={(e) => setFormData({ ...formData, role: e })}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.admin}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddAdminsModal;
